<template>
  <div>
    <a-row :gutter="16">
      <a-col :span="6"></a-col>
      <a-col :span="12">
        <a-card>
          <a-descriptions size="small" title="Wniosek">
            <a-descriptions-item :span="3" label="Imię i nazwisko">
              {{ formData.personal.name }} {{ formData.personal.surname }}
            </a-descriptions-item>
            <a-descriptions-item :span="3" label="PESEL/Paszport">
              {{ formData.personal.personIdentificationNumber }}
            </a-descriptions-item>
            <a-descriptions-item :span="3" label="Dom studencki">
              {{ deviceData.dorm.name }}
            </a-descriptions-item>
            <a-descriptions-item :span="3" label="Numer pokoju">
              {{ formData.university.dormRoom }}
            </a-descriptions-item>
            <a-descriptions-item :span="3" label="Adres zameldowania">
              {{ formData.home.street }} {{ formData.home.number }},
              {{ formData.home.zipCode }} {{ formData.home.city }},
              {{ formData.home.state }}, {{ formData.home.country }}
            </a-descriptions-item>
            <a-descriptions-item :span="3" label="Uczelnia">
              {{ formData.university.name }}
            </a-descriptions-item>
            <a-descriptions-item :span="3" label="Kierunek studiów (semestr)">
              {{ formData.university.faculty }} (semestr {{ computedSemester }})
            </a-descriptions-item>
            <a-descriptions-item :span="3" label="Numer albumu">
              {{ formData.university.index }}
            </a-descriptions-item>
            <a-descriptions-item :span="3" label="Adres e-mail">
              {{
                formData.personal.emailAddress !== null
                    ? formData.personal.emailAddress
                    : "- brak -"
              }}
            </a-descriptions-item>
            <a-descriptions-item :span="3" label="Adres MAC urządzenia">
              {{ deviceData.macAddress }}
            </a-descriptions-item>
            <a-descriptions-item :span="3" label="Akceptacja regulaminu sieci Domu Studenta PŚk">
              {{ formData.terms.accepted ? "Tak" : "Nie" }}
            </a-descriptions-item>
          </a-descriptions>
        </a-card>
      </a-col>
    </a-row>
    <a-row style="text-align: center; margin-top: 24px">
      <p style="max-width: 800px; margin-left: auto; margin-right: auto">
        Potwierdzam prawidłowość zawartych powyżej danych i wyrażam zgodę na ich
        przetwarzanie zgodnie z Rozporządzeniem Parlamentu Europejskiego i Rady
        (UE) 2016/679 z dnia 27 kwietnia 2016 roku oraz ustawą z dnia 10 maja
        2018 roku o ochronie danych osobowych (Dz.U.2018 poz. 1000) zgodnie z
        informacjami zawartymi w
        <a href="#" target="_blank" @click="$router.push({ name: 'RODO' })">klauzuli informacyjnej RODO</a>.

        <!-- I hereby consent to my personal data being processed by Technology University in for the purpose of considering my application for the access to the network. More info in <a href="#" @click="showRodoConfirm"
          >RODO information</a
        > -->
      </p>
    </a-row>
    <a-row style="text-align: center">
      <a-button style="margin-right: 24px" type="default" @click="back">
        <a-icon type="left"/>
        Wróć
      </a-button>
      <a-button :loading="submitting" type="primary" @click="submit">
        Zatwierdź i wygeneruj wniosek papierowy
        <a-icon type="check"/>
      </a-button>
    </a-row>
  </div>
</template>

<script>
import httpClient from "@/utils/httpClient";

const semestersDictionary = [
  {key: 1, value: "pierwszy"},
  {key: 2, value: "drugi"},
  {key: 3, value: "trzeci"},
  {key: 4, value: "czwarty"},
  {key: 5, value: "piąty"},
  {key: 6, value: "szósty"},
  {key: 7, value: "siódmy"},
  {key: 8, value: "ósmy"},
  {key: 9, value: "dziewiąty"},
  {key: 10, value: "dziesiąty"},
  {key: 11, value: "jedenasty"},
  {key: 12, value: "dwunasty"},
  {key: 13, value: "trzynasty"},
  {key: 14, value: "czternasty"},
  {key: 15, value: "piętnasty"},
  {key: 16, value: "inny"},
  {key: 0, value: "nie dotyczy"},
];

export default {
  data() {
    return {
      formData: {},
      deviceData: {},
      submitting: false,
    };
  },
  created() {
    console.log("Data: ", this.$store.getters["getCompleteForm"]);
    this.formData = this.$store.getters["getCompleteForm"];
    this.deviceData = this.$store.getters["getUserConnectionDetails"];
  },
  methods: {
    submit: function () {
      this.submitting = true;
      this.formData.dorm = this.deviceData.dorm.code
      console.log("Device: ", this.deviceData);
      this.formData.device = {
        ipAddress: this.deviceData.local,
        macAddress: this.deviceData.macAddress,
        browser: this.deviceData.browser,
      }
      httpClient.post("/accounts", this.formData).then((response) => {
        console.log(response)
        this.$message.success("Wniosek został wysłany")
        this.$emit("nextStep");
      }).catch((error) => {
        if (error.response && error.response.status === 400) {
          this.$message.error("Wystąpił problem z wnioskiem.")
        }
        if (error.response && error.response.status === 422) {
          this.$message.error("Konto już istnieje, zaloguj się!")
        }
      }).finally(() => {
        this.submitting = false
      })
    },
    back: function () {
      this.$emit("prevStep");
    },
  },
  computed: {
    isVerificationCompleted: function () {
      return true;
    },
    computedSemester: function () {
      let semester = semestersDictionary.find(
          (s) => s.key === this.formData.university.semester
      );
      return semester !== undefined ? semester.value : "nieznany";
    },
  },
};
</script>
